<template>
  <div class="feedback">
    <van-field
      v-model="message"
      rows="5"
      autosize
      label=""
      type="textarea"
      placeholder="说点什么...."
    />
    <Uploader @afterRead="afterRead" :list="list"/>
    <button @click="submit" class="submit">提交</button>
  </div>
</template>

<script>
import { Field } from 'vant';
import { Uploader } from '@/components';
export default {
  name: 'Feedback',
  components: { 'van-field': Field, Uploader },
  data () {
    return {
      message: '',
      list: []
    };
  },
  methods: {

    /* 上传头像 */
    afterRead (file) {
      const { $http, $utils } = this;
      const formData = new FormData();
      formData.append('file', file[0].file);
      console.log(file);
      $http.post('upload/feedback', formData).then((res) => {
        let data = res.data || {};
        $utils.successToast('上传成功');
        this.list.push({ src: data.path, file: data.saveName });
      });
    },

    /* 提交反馈意见 */
    submit () {
      const { $http, $utils, $router, message, list } = this;
      if (message) {
        $http.post('h5/feedback', {
          content: message,
          imgName: list.map((item) => item.file).join(',')
        }).then((res) => {
          $utils.successToast({
            message: '提交成功',
            onClose: () => {
              $router.go(-1);
            }
          });
        });
      } else {
        $utils.toast('请填写反馈意见');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.feedback {
  padding: 28px;
  /deep/.van-cell{
    background: #F9FAFC;
    margin-bottom: 40px;
  }
  .submit {
    display: block;
    margin: 178px auto 0;
    width: 450px;
    height: 76px;
    background: linear-gradient(90deg, #2E86FF 0%, #5FA9FF 100%);
    box-shadow: 0px 6px 40px rgba(95, 169, 255, 0.3);
    border-radius: 44px;
    font-size: 28px;
    font-weight: 500;
    line-height: 46px;
    color: #fff;
  }
}
</style>